import Icon from '../../components/Icon.vue'

Icon.register({"brands/quinscape":{"width":489,"height":512,"paths":[{"d":"M301.9 474.6H300.6C213.3 474.6 142.5 403.8 142.5 316.5S213.3 158.4 300.6 158.4C395.5 158.4 468.8 241.5 457.6 335 461.6 340.1 465.8 344.6 468.8 350.3 482.2 320 489.1 287.9 489.1 252.6 489.1 117.5 379.6 8 244.5 8 109.5 8 0 117.5 0 252.6S109.5 497.2 244.5 497.2C269.3 497.2 292.3 494 314.9 487.1 309.7 483.6 305.9 478.9 301.5 474.5L301.9 474.6zM280.7 404.8C280.7 350 325.1 305.6 379.9 305.6 434.7 305.6 479.1 350 479.1 404.8 479.1 459.6 434.7 504 379.9 504 325.1 504 280.7 459.6 280.7 404.8"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/quinscape.js
// module id = IT1x
// module chunks = 0